import React, { useMemo, useContext } from 'react';
import { HELP_DESK_PRIORITY_LABEL_KEYS } from '@ubeya/shared/constants/helpDesk';
import ConfigContext from '../../../contexts/ConfigContext';
import HelpDeskFlatMultiSelectFilter from './HelpDeskFlatMultiSelectFilter';
import useHelpDeskMultiSelectFilter from './useHelpDeskMultiSelectFilter';

const PRIORITY_OPTIONS_BASE = Object.entries(HELP_DESK_PRIORITY_LABEL_KEYS).map(([value, labelKey]) => ({
  value,
  labelKey
}));

const HelpDeskPriorityFilter = ({ defaultValue, handleClose, onApply, hideLayout = false }) => {
  const { t } = useContext(ConfigContext);

  const initialMap = useMemo(() => {
    if (!defaultValue) return {};
    const values = Array.isArray(defaultValue) ? defaultValue : [defaultValue];
    return values.reduce((acc, v) => {
      if (v) acc[v] = v;
      return acc;
    }, {});
  }, [defaultValue]);

  const { selectedMap, handleToggle, clearSelection, applySelection } = useHelpDeskMultiSelectFilter(initialMap, {
    onApply,
    hideLayout,
    handleClose
  });

  const options = useMemo(
    () => PRIORITY_OPTIONS_BASE.map(({ value, labelKey }) => ({ key: value, label: t(labelKey), value })),
    [t]
  );

  return (
    <HelpDeskFlatMultiSelectFilter
      name={t('priority')}
      options={options}
      selectedMap={selectedMap}
      onToggle={handleToggle}
      onClear={clearSelection}
      onApply={() => applySelection(selectedMap)}
      handleClose={handleClose}
      hideLayout={hideLayout}
    />
  );
};

export default HelpDeskPriorityFilter;
